import { cn } from '@/shadcn/lib/utils';

import { Ellipsis } from '@/components/ui/ellipsis/ellipsis';
import { WorkspaceVersionBadge } from './WorkspaceVersionBadge';

type Props = {
  color: string;
  name: string;
  version?: unknown;
  className?: string;
  // Push the version badge to the trailing edge (e.g. in the filter dropdown so
  // badges line up in a column). Default keeps it snug after the name.
  alignBadgeEnd?: boolean;
  // Extra classes for the version badge (e.g. hiding it on narrow navbars).
  badgeClassName?: string;
};

// Read-only workspace display: color dot + name + version badge.
// Shared by the workspace filter dropdown items and the read-only header.
// The name truncates first; the version badge keeps its full width so its
// type label ("release", "fix", ...) is never cropped. A long badge value
// still truncates internally via WorkspaceVersionBadge's own overflow rules.
export const WorkspaceTag = ({
  color,
  name,
  version,
  className,
  alignBadgeEnd,
  badgeClassName
}: Props) => (
  <div
    className={cn(
      'flex min-w-0 items-center gap-1.5',
      alignBadgeEnd && 'grow',
      className
    )}
  >
    <span
      aria-hidden
      className="size-2.5 shrink-0 rounded-full"
      style={{ backgroundColor: color }}
    />
    <Ellipsis className="min-w-0 text-sm">{name}</Ellipsis>
    <WorkspaceVersionBadge
      className={cn(
        'shrink-0',
        alignBadgeEnd ? 'ml-auto pl-2' : 'ml-1',
        badgeClassName
      )}
      version={version}
    />
  </div>
);
